import {
    axiosJwt
} from '@/shared/auth/axios-lib'
import {
    errorHandler
} from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}/administracao`

export default {
    obterTodos() {
        return axiosJwt.get(`${api}/controleacesso/perfisacesso`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterPorId(id) {
        return axiosJwt.get(`${api}/controleacesso/perfisacesso/${id}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    inserirPerfilAcesso(perfilAcesso) {
        return axiosJwt.post(`${api}/controleacesso/perfisacesso`, perfilAcesso)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    atualizarPerfilAcesso(perfilAcesso) {
        return axiosJwt.put(`${api}/controleacesso/perfisacesso`, perfilAcesso)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    associarRegrasAcesso(perfilRegrasAcesso) {
        return axiosJwt.post(`${api}/controleacesso/perfisacesso/${perfilRegrasAcesso.perfilAcessoId}/regrasacesso`, perfilRegrasAcesso)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    desassociarRegraAcesso(perfilRegraAcesso) {
        return axiosJwt.patch(`${api}/controleacesso/perfisacesso/${perfilRegraAcesso.perfilAcessoId}/regraacesso`, perfilRegraAcesso)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    desassociarRegrasAcesso(perfilRegrasAcesso) {
        return axiosJwt.patch(`${api}/controleacesso/perfisacesso/${perfilRegrasAcesso.perfilAcessoId}/regrasacesso`, perfilRegrasAcesso)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    atualizarPerfilRegraAcesso(perfilRegraAcesso) {
        return axiosJwt.put(`${api}/controleacesso/perfisacesso/${perfilRegraAcesso.perfilAcessoId}/regraacesso`, perfilRegraAcesso)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    clonarPerfilAcesso(perfilAcessoId) {
        return axiosJwt.post(`${api}/controleacesso/perfisacesso/${perfilAcessoId}/clonar`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    }

}
